import React, { useState, useEffect } from 'react';
import { Sidebar } from '@/components/Sidebar';
import { Header } from '@/components/header/Header';
import { useTheme } from '@/hooks/useTheme';
import { UnclosedTripsNotifier } from '@/components/alertsNotifications/UnclosedTripsNotifier';

export function Layout({ children }) {

  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem('sidebar-collapsed');
      if (saved !== null) {
        return saved === 'true';
      }
      return window.innerWidth < 768;
    }
    return false;
  });

  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.innerWidth < 768;
    }
    return false;
  });

  const { theme, toggleTheme } = useTheme();

  useEffect(() => {
    if (!isMobile) {
      localStorage.setItem('sidebar-collapsed', String(sidebarCollapsed));
    }
  }, [sidebarCollapsed, isMobile]);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (mobile) {
        setSidebarCollapsed(true);
      } else {
        const saved = localStorage.getItem('sidebar-collapsed');
        setSidebarCollapsed(saved !== null ? saved === 'true' : false);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const marginLeft = isMobile ? 0 : (sidebarCollapsed ? "4rem" : "15rem");

  return (
    <div className="fixed inset-0 flex bg-background text-foreground">
      <Sidebar
        isCollapsed={sidebarCollapsed}
        isMobile={isMobile}
        setSidebarCollapsed={setSidebarCollapsed}
        theme={theme}
      />

      <div
        className="flex flex-col flex-1 overflow-hidden"
        style={{ marginLeft }}
      >
        <Header
          theme={theme}
          toggleTheme={toggleTheme}
          toggleSidebar={toggleSidebar}
        />

        <main className="flex-1 overflow-y-auto p-2 sm:p-4 lg:p-4">
          {children}
        </main>
      </div>

      <UnclosedTripsNotifier />
    </div>
  );
}